<template>
  <div id="banner" class="carousel slide" data-ride="carousel" data-interval="198000">
    <ol class="carousel-indicators">
      <li data-target="#banner" data-slide-to="0" class="active"></li>
      <li data-target="#banner" v-for="(item,index) in bannerList" :key="item.id" :data-slide-to="index+1"></li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item active">
        <video src="/static/video/sjzeis20202_1.mp4" muted="muted" autoplay="autoplay" loop="loop" style="width: 100%; height: 100%; object-fit: cover;"></video>
      </div>
      <div class="carousel-item" v-for="(item,index) in bannerList" :key="item.id" :class="index+1 == 0 ? 'active' : ''">
        <img class="d-block mx-auto" v-bind:src="item.img" alt="" />
      </div>
    </div>
    <a class="carousel-control-prev" href="#banner" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#banner" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</template>

<script>
  const axios = require('axios');
  // let vm = new Vue({
  //   el:"#banner",
  export default {
    data(){
      return {
        bannerList: null,
        imgUrl: "https://www.sjzeis.com"
      }
    },
    mounted () {
      let that = this;
      // 获取banner
      axios.get(that.global.apiUrl + '/web/banner/queryAllByType?type=index')
        .then(function(response){
          if (response.data.success && response.data.data.length > 0) {
            that.bannerList = response.data.data;
            for (var index in that.bannerList) {
              let item = that.bannerList[index]
              item.img = that.global.apiUrl + '/file/getImgStream?idFile=' + item.idFile
              // console.log(item)
            }
          }
        }).catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    methods:{
        get_bannerlist(){
            let that = this;
            axios.get(that.global.apiUrl + '/web/banner/queryAllByType?type=index')
                .then(response=>{
                    // console.log(response);
                    this.bannerList = response.data;
                    for (var index in this.bannerList) {
                      let item = this.bannerList[index]
                      item.img = that.global.apiUrl + '/file/getImgStream?idFile=' + item.idFile
                      // console.log(item)
                    }

                }).catch(error=>{
                    console.log(error.response)
            });
        }
    },
  }
  // })
</script>

<style>
  #banner {
    height: 560px;
  }
  #banner .carousel-item {
    height: 560px;
  }
  #banner .carousel-item img {
    width: 100%;
    max-width: 1920px;
    height: 560px;
  }
</style>



// WEBPACK FOOTER //
// src/views/banner/banner.vue